import { pastChallengesIds } from "@artists/challenges-testkit"
import { SearchField } from "@artists/uikit"
import { Box } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useTypedSearchParams } from "react-router-typesafe-routes/dom"

import { Root } from "../../../../utils"
import { useSearch } from "./search.hook"

export const Search = () => {
	const { t } = useTranslation("past")
	const { onKeyDown, onChange, reset } = useSearch()
	const [{ search }] = useTypedSearchParams(Root.Past)

	return (
		<Box sx={{ maxWidth: "450px", width: "100%", mt: 3, mx: "auto" }}>
			<SearchField
				size='small'
				label={t`search`}
				onKeyDown={onKeyDown}
				onValueChange={onChange}
				initialValue={search}
				data-testid={pastChallengesIds.searchField}
				clearBtnId={pastChallengesIds.clearBtn}
				onClear={reset}
				fullWidth
			/>
		</Box>
	)
}
